import * as React from 'react';
import styles from "./styles.module.css";
import { Checkbox, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useLanguageLocale } from '../../../hooks/language-locale-hooks';
import AddButton from '../../../components/AddButton/AddButton';
import OrganizationFilterSelect from '../../../components/OrganizationFilterSelect/OrganizationFilterSelect';
import TableSearchInput from '../../../components/TableSearchInput/TableSearchInput';
import FirePanelListTable from './FirePanelListTable';
import BuildingFilterSelect from '../../../components/BuildingFilterSelect/BuildingFilterSelect';
import { DropDownListComponent } from '../../../components/DropDownList/DropDownListComponent';
import DownloadButton from '../../../components/DownloadButton/DownloadButton';
export interface Props {
}

const FirePanelList: React.FunctionComponent<Props> = () => {

    const { t } = useLanguageLocale();
    const theme = useTheme();
    const md = useMediaQuery(theme.breakpoints.up('md'));
    const [orgnizationId, setOrgnizationId] = React.useState<string | undefined>();
    const [buildingId, setBuildingId] = React.useState<string>('');
    const [searchText, setSearchText] = React.useState<string | undefined>();
    const [isFavorite, setIsFavorite] = React.useState<boolean | undefined>();
    const [currentPage, setCurrentPage] = React.useState<number>(0);

    const handleOrgnizationChange = (e: string) => {
        setOrgnizationId(e);
        setBuildingId('');
    }

    const handleBuildingChange = (e: string) => {
        setBuildingId(e);
    }

    const handleSearchTextChange = (value: string) => {
        setSearchText(value);
    }

    const handleFavoriteCheckboxChange = (e: any) => {
        setIsFavorite(e.target.checked);
    }

    React.useEffect(() => {
        setCurrentPage(0);
    }, [orgnizationId, buildingId, searchText, isFavorite])

    return (
        <>
            <div id="asset-firepanel-ticket-container" data-testid="asset-firepanel-ticket-container">
                <div className={styles.header1}>
                    <span>
                        <span style={{ display: 'none', columnGap: '15px' }}>
                            <AddButton testId={'system-add-button'} text={t('ASSETS_DETAILS.ADD_SYSTEMS')} callback={() => { }} />
                            <DownloadButton onClick={() => { }} testId="fire-panel-list-downlaod-button" />
                        </span>
                    </span>
                    <div className={styles.block1}>
                        <Typography
                            id="firepanel-ticket-favorite-filter-checkbox-lable"
                            data-testid="firepanel-ticket-favorite-filter-checkbox-lable"
                            style={{ alignSelf: 'center' }} variant="body2">
                            {t('ASSETS_DETAILS.SHOW_FAVORITE_SYSTEMS')}
                        </Typography>
                        <Checkbox id="firepanel-ticket-favorite-filter-checkbox" onChange={handleFavoriteCheckboxChange}
                        />
                    </div>
                </div>
                <div className={styles.filterBlock}>
                    <OrganizationFilterSelect callback={handleOrgnizationChange} defaultValue={''} />
                    <BuildingFilterSelect callback={handleBuildingChange} defaultValue={buildingId} organizationId={orgnizationId} />

                    <DropDownListComponent
                        disabled={true}
                        list={[]}
                        value={t('SEARCH.ALL_PANELS')}
                        handleSelection={() => { }}
                        selected={''}
                        defaultSelection={''}>
                    </DropDownListComponent>
                    <DropDownListComponent
                        disabled={true}
                        list={[]}
                        value={t('SEARCH.ALL_INPUT_ZONES')}
                        handleSelection={() => { }}
                        selected={''}
                        defaultSelection={''}>
                    </DropDownListComponent>
                    <DropDownListComponent
                        disabled={true}
                        list={[]}
                        value={t('SEARCH.ALL_MODULES')}
                        handleSelection={() => { }}
                        selected={''}
                        defaultSelection={''}>
                    </DropDownListComponent>

                    <div style={{ marginRight: '1%', display: 'inline' }}>
                        <TableSearchInput testId={'search'} value={''} callback={handleSearchTextChange} />
                    </div>
                </div>
                <div className={styles.tableContainer}>
                    <FirePanelListTable
                        organizationId={orgnizationId}
                        buildingId={buildingId}
                        searchText={searchText}
                        isFavorite={isFavorite}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                    />
                </div>
            </div>
        </>
    );
};

export default FirePanelList;
